export const REQUEST_ORDERS_LOADING = 'REQUEST_ORDERS_LOADING';
export const REQUEST_ORDERS_SUCCESS = 'REQUEST_ORDERS_SUCCESS';
export const REQUEST_ORDER_DETAILS_SUCCESS = 'REQUEST_ORDER_DETAILS_SUCCESS';
export const ADD_OR_UPDATE_ORDERS = 'ADD_OR_UPDATE_ORDERS';
export const ADD_OR_UPDATE_ORDER_DETAILS = 'ADD_OR_UPDATE_ORDER_DETAILS';
